export { ProjectsTable } from './ProjectsTable';
export { ProjectLeftBar, ProjectName } from './projects-table.styled';
